module.exports = __webpack_public_path__ + "static/media/car-home-combined-01.a7a0f567.svg";